export const ALBUM_NAVIGATION_DIRECTIONS = {
  previous: 'PREVIOUS',
  next: 'NEXT',
};

export const ALBUM_NAVIGATION_DIRECTIONS_LIST = Object.values(ALBUM_NAVIGATION_DIRECTIONS);

export const PAGE_SIDES = {
  right: 'RIGHT',
  left: 'LEFT',
};

export const PAGE_SIDES_LIST = Object.values(PAGE_SIDES);

export const OPTIONS_LABELS = {
  'endsheet-type': 'End Sheet',
  'cameo-position': 'Cameo',
  'hinge-type': 'Style',
  'book-size': 'Size',
  'cover-design': 'Color',
  'paper-type': 'Paper Type',
  'cover-type': 'Cover Style',
};

export const TABLE_LABELS = {
  album: ['ITEM', 'IMAGES', 'PAGES', 'PRICE'],
  box: ['ITEM', 'PRICE'],
};

// Max file size per photo in MB
export const MAX_FILE_SIZE = 20;

export const ALBUM_FILE_TYPES = ['image/jpeg'];

export const ALBUM_TYPE_KEYS = {
  classic: 'classic',
  premier: 'premier',
  deluxe: 'deluxe',
};

export const albumLayoutTypes = ['MINIMALIST', 'CLASSIC', 'BOLD'];

// TODO: ask BE if they could sort them instead of having to do it in the FE
export const SORTED_ALBUM_TYPES = ['classic', 'premier', 'deluxe'];

export const STORAGE_KEY_ALBUM_FLOW_ID = 'STORAGE_KEY_ALBUM_FLOW_ID';

export const FIRST_TIME_EXP_STORAGE_KEY_CUSTOMIZE_STEP_PROGRESS =
  'ZOLA_PHOTOBOOKS_CUSTOMIZE_STEP_FIRST_TIME_EXPERIENCE_PROGRESS';

export const FIRST_TIME_EXP_STORAGE_KEY_CUSTOMIZE_STEP_MAIN =
  'ZOLA_PHOTOBOOKS_CUSTOMIZE_STEP_FIRST_TIME_EXPERIENCE_MAIN';

export const ORDER_STATUSES = ['ORDER_PLACED', 'PROCESSING', 'SHIPPED', 'CANCELED'];

export const ORDER_CANCEL_TIMEFRAME = 6; // Hours
export const ORDER_CANCEL_TIMEFRAME_STAGE = 0.0833333; // 5 minutes in hours

export const VALIDATION_KEYS = {
  customizationMissing: 'CUSTOMIZATION_MISSING', // An album without any customization
  customizationUuidMissing: 'CUSTOMIZATION_UUID_MISSING', // An album with an invalid customization
  customizationHeightInvalid: 'CUSTOMIZATION_HEIGHT_INVALID', // An album which height is not in the sizes we offer
  customizationWidthInvalid: 'CUSTOMIZATION_WIDTH_INVALID', // An album which width is not in the sizes we offer
  spreadIndexMissing: 'SPREAD_INDEX_MISSING', // An album with a spread that has no proper positioning
  layoutUuidMissing: 'LAYOUT_UUID_MISSING', // An album with a spread not linked to a layout
  slotKeyMissing: 'SLOT_KEY_MISSING', // A slot that doesn't belong to the layout
  slotInvalidWidth: 'SLOT_INVALID_WIDTH', // A slot with a wrong width, 0 or more than the album width
  slotInvalidHeight: 'SLOT_INVALID_HEIGHT', // A slot with a wrong height, 0 or more than the album height
  customizationNotEnoughSpreads: 'CUSTOMIZATION_NOT_ENOUGH_SPREADS', // An album with less than 10 non empty spreads
  customizationTooManySpreads: 'CUSTOMIZATION_TOO_MANY_SPREADS', // An album with more than 40/45 non empty spreads
  lowResPhotos: 'LOW_RES_PHOTOS', // A slot with a low resolution photo
  spreadEmpty: 'SPREAD_EMPTY', // An empty spread (no photo at all)
  slotEmpty: 'SLOT_EMPTY', // An empty slot (no photo on the slot)
  duplicatePhoto: 'DUPLICATE_PHOTOS', // A photo used twice in an album
  skippedPages: 'SKIPPED_PAGES', // A spread that hasn't been reviewed by the user
};

export const ERROR_LEVELS = {
  error: 'ERROR',
  warning: 'WARNING',
};

export const ERROR_TYPE = {
  system: 'SYSTEM',
  user: 'USER',
};

export const UUID_LENGTH = 36;

export const COVER_FONT_SIZE_PT_RANGE = { min: 24, max: 60 };

export const MAX_COVER_LINES = 4;



// WEBPACK FOOTER //
// ./src/photobooks/constants/albumConstants.js